import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { filterDateAnim } from 'src/app/models/consts/anims';
import { MediaObserver } from '@angular/flex-layout';
import { ClientNotesService } from 'src/app/services/apiclient/clientnotes/clientnotes.service';
import { ToolsService } from 'src/app/services/tools/tools.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CurrencyService } from 'src/app/services/manage/currency/currency.service';
import { ClientMerchantsService } from 'src/app/services/apiclient/clientmerchants/clientmerchants.service';
import * as moment from 'moment';
import { TranslateArrayService } from 'src/app/services/translateArray/translate';
@Component({
  selector: 'app-notes',
  templateUrl: './notes.component.html',
  styleUrls: ['./notes.component.css'],
  animations: [
    filterDateAnim,
  ]
})

export class NotesComponent implements OnInit {

  @ViewChild('pageTitle') pageTitle: ElementRef | any;
  @ViewChild(MatPaginator) paginator: MatPaginator | any;
  @ViewChild(MatSort) sort: MatSort | any;

  clientNotes$: any[] | any;

  dataSource: MatTableDataSource<any> = new MatTableDataSource<any>();
  displayedColumns: string[] = ['date', 'user_denomination', 'point_of_sale_name', 'sale_method_name', 'total_ttc', 'print'];

  loader: boolean = true;
  noteLoader: boolean = false;

  titlePositionTop: number | any;

  filterDateAnimFlag: boolean = false;
  get getToggleFilterDate(): string { return this.filterDateAnimFlag ? "show" : "hide"; }

  currMerchant: any;

  constructor(
    private media: MediaObserver,
    private clientNoteApi: ClientNotesService,
    private tools: ToolsService,
    private route: ActivatedRoute,
    private router: Router,
    private clientMerchantApi: ClientMerchantsService,
    private currencyMng: CurrencyService,
    private TranslateArrayService: TranslateArrayService
  ) {

    this.media.asObservable().subscribe(media => {
      if (this.titlePositionTop) {
        this.setTitlePosition();
      }
    });
  }

  ngOnInit() {
    this.route.params.subscribe((params: any) => {
      if (params.merchantId) {
        this.clientMerchantApi.getMerchant(params.merchantId).subscribe(merchant => {
          this.currMerchant = merchant;
          this.currencyMng.setCurrCurrency(merchant.currency);
          this.getNotes();
        });
      } else {
        this.tools.setPageClient("notes");
        this.getNotes();
      }
    });
  }

  goPrintTicket(link_invoice: string) {
    window.open(link_invoice);
  }

  setTitlePosition() {
    setTimeout(() => {
      this.titlePositionTop = this.pageTitle?.nativeElement.getBoundingClientRect().top + 10;
      if(this.currMerchant && !this.filterDateAnimFlag)
        this.titlePositionTop=0;
      if(this.currMerchant && this.filterDateAnimFlag)
        this.titlePositionTop=+100;
    });
  }

  setNoteLoader($event: boolean) {
    if ($event)
      this.filterDateAnimFlag = false;
    this.noteLoader = $event;
  }

  setNotestoTable(notes_value: any) {
    let notes: any = this.transformForArray(notes_value);
    setTimeout(() => {
      this.dataSource.data =notes;
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.TranslateArrayService.get(this.dataSource.paginator);
    });
    this.setTitlePosition();
    this.loader = false;
  }

  setNotes($event: any) {
    this.setNotestoTable($event);
  }

  goBack(): void {
    this.router.navigate(["/home/merchantOptions/" + this.currMerchant.id_user]);
  }

  getNotes() {
    const merchantId = (this.currMerchant) ? parseInt(this.currMerchant.id_user) : null;
    this.clientNoteApi.getNotes(null, null, merchantId).subscribe(notes_value => {
      this.setNotestoTable(notes_value);
    });
  }

  // makes easy sort in array
  transformForArray(not: any) {
    let notes: any = [];
    not.forEach((element: any, i: any) => {
      let note = {
        currency: element.currency,
        date: element.date,
        user_denomination: element.user_account.denomination,
        point_of_sale_name: element.point_of_sale.denomination,
        lettering: element.lettering,
        sale_method_name: element.sale_method.name,
        total_ttc: element.total_ttc_str,
        print: element.link_invoice,
      }
      notes.push(note);
    });

    //on tri
    notes = notes.sort(function (a: any, b: any) {
      let a_:any=moment(new Date(a.date));
      let b_:any=moment(new Date(b.date));
     return a_-b_;

  });
   


    return notes;
  }

  setFilteranim(){
    this.filterDateAnimFlag = !this.filterDateAnimFlag,
    this.setTitlePosition(); }
}
